<template>
  <div>
    <section role="main" class="empty">
      <div class="container">
        <div class="row icon-tabs">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item">
              <router-link to="/executive" class="nav-link"
                ><img src="/img/icons/executives.png" alt="Executives" />
                Executives</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/company" class="nav-link"
                ><img src="/img/icons/companies.png" alt="Companies" />
                Companies</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/news" class="nav-link active"
                ><img src="/img/icons/deals.png" alt="News" /> News</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/deals-transactions" class="nav-link"
                ><img src="/img/icons/deals.png" alt="Deals & Transactions" />
                Deals & Transactions</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/listing" class="nav-link"
                ><img src="/img/book.png" style="height: 23px" />
                Listing</router-link
              >
            </li>
            <!-- <li class="nav-item">
              <router-link to="/commentaries" class="nav-link"
                ><img src="/img/icons/commentaries.png" alt="Commentaries" />
                Commentaries</router-link
              >
            </li> -->
            <li class="nav-item">
              <router-link to="/interesting-bites" class="nav-link"
                ><img
                  src="/img/icons/interesting.png"
                  alt="Interesting Facts"
                />
                Interesting Facts</router-link
              >
            </li>
            <!-- NOTE: Temporary hide the open position tab. -->
            <!-- <li class="nav-item">
              <router-link to="/open-positons-new" class="nav-link"
                ><img src="/img/icons/position.png" alt="Open Position" /> Open
                Positons</router-link
              >
            </li> -->
            <li class="">
              <a
                class="nav-link"
                style="
                  font-weight: bold !important;
                  margin-top: 8px;
                  font-size: 13px;
                  color: #1f3342;
                  margin-left: 290px;
                "
              >
                {{ count }}</a
              >
            </li>
          </ul>
          <div class="tab-content mb-3">
            <div>
              <div class="container px-0">
                <div class="row">
                  <div class="col-lg-8 col-sm-8">
                    <!-- <form class="form-search form-inline"> -->
                    <input
                      type="text"
                      class="search-query"
                      style="border: 0px none; width: 100%"
                      v-on:keyup.enter="getList(0)"
                      v-model="searchObj.keyword"
                      placeholder="Search..."
                    />
                    <!-- </form> -->
                  </div>
                  <div
                    class="col-lg-4 col-sm-4 col-6 text-right company-offcanvas"
                  >
                    <button class="menuButton" id="openOffcanvas" v-on:click="openCloseModel()">
                      <div class="filter-title-name">Build My Search</div>
                    </button>
                  </div>
                </div>
                <hr class="mt-0 mb-2" />
              </div>
              <div v-if="showDidYouMean" class="did-you-mean">
                Did you mean: <span class="did-you-mean-prompt">{{ searchedPrompt }}</span>
              </div>
              <div v-show="is_show" class="row advasearch-data mt-1">
                <!-- <div class="col-lg-2 col-sm-4 col-6" v-if="isShowSubsector">
                  <label class="label">Deal Stage</label>
                  <Multiselect
                    mode="single"
                    trackBy="name"
                    label="name"
                    valueProp="id"
                    v-model="searchObj.deal_stage_ids"
                    :options="dealStageList"
                    searchable="true"
                    placeholder="Select"
                    @search-change="searchDealStage($event)"
                  />
                </div> -->
                <!-- <div class="col-lg-2 col-sm-4 col-6">
                  <label class="label">From Date</label>
                  <datepicker
                    v-model="searchObj.from_date"
                    inputFormat="dd/MM/yyyy"
                    placeholder="From Date"
                    class="form-control"
                    style="background-color: white !important; height: 35px"
                    :clearable="false"
                    :upperLimit="
                      searchObj.to_date ? searchObj.to_date : new Date()
                    "
                    @click="onClickFromDate()"
                  >
                  </datepicker>
                </div> -->
                <!-- <div class="col-lg-2 col-sm-4 col-6">
                  <label class="label">To Date</label>
                  <datepicker
                    v-model="searchObj.to_date"
                    inputFormat="dd/MM/yyyy"
                    class="form-control"
                    placeholder="To Date"
                    :clearable="false"
                    style="background-color: white !important; height: 35px"
                    :lowerLimit="
                      searchObj.from_date ? searchObj.from_date : null
                    "
                    :upperLimit="new Date()"
                    @click="onClickFromDate()"
                  >
                  </datepicker>
                </div> -->
                <!-- <div class="col-lg-2 col-sm-4 col-6">
                  <label class="label">Date Period</label>
                  <Multiselect
                    mode="single"
                    trackBy="value"
                    label="value"
                    valueProp="id"
                    v-model="searchObj.date_period"
                    :options="date_periods"
                    searchable="true"
                    placeholder="Select"
                    @change="dateFilter($event)"
                    @click="onClickDatePeriod()"
                  />
                </div> -->
                <!-- <div class="col-lg-2 col-sm-4 col-6">
                  <label class="label">Location</label>
                  <Multiselect
                    mode="single"
                    trackBy="country_name"
                    label="country_name"
                    valueProp="id"
                    v-model="searchObj.country_ids"
                    :options="cityList"
                    :noOptionsText="'Enter Text'"
                    searchable="true"
                    placeholder="Select"
                    @search-change="searchCityName($event)"
                  />
                </div> -->

                <!-- <div class="col-lg-2 col-sm-4 col-6">
                  <label class="label">Region</label>
                  <Multiselect
                    mode="single"
                    trackBy="region_name"
                    label="region_name"
                    valueProp="id"
                    placeholder="Select"
                    v-model="searchObj.region_ids_new"
                    :options="regionList"
                    searchable="true"
                    @search-change="searchRegionName($event)"
                  />
                </div> -->
                <!-- <div class="col-lg-2 col-sm-4 col-6 mt-2">
                  <label class="label">Company Type</label>
                  <Multiselect
                    mode="single"
                    trackBy="value"
                    label="value"
                    valueProp="id"
                    v-model="searchObj.company_types"
                    :options="company_types"
                    searchable="true"
                    placeholder="Select"
                  />
                </div> -->
                <!-- <div class="col-lg-2 col-sm-4 col-6 mt-2">
                  <label class="label">Past Company</label>
                  <Multiselect
                    mode="single"
                    trackBy="company_name"
                    label="company_name"
                    valueProp="id"
                    placeholder="Select"
                    v-model="searchObj.prev_company_id"
                    :options="companyList"
                    :noOptionsText="'Enter Text'"
                    searchable="true"
                    @search-change="searchCompanyName($event)"
                  />
                </div> -->
              </div>
              <!-- <hr /> -->
              <div
                class="row mt-4"
                style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
                v-for="(data, index) in list"
                :key="index"
              >
                <div class="col-lg-2 col-sm-2 text-center">
                  <a
                    style="cursor: pointer"
                    v-on:click="goToView('/company-detail/' + data.company_id)"
                  >
                    <img
                      :title="data.company_name"
                      :src="
                        data.company_logo
                          ? data.company_logo
                          : '/img/user-pic.png'
                      "
                      alt=""
                      width="40"
                      height="40"
                    />
                    <!-- class="md-size" -->
                  </a>
                  <br />
                  <a
                    :title="
                      data.country_code ? data.country_code.country_name : ''
                    "
                  >
                    <country-flag
                      :country="
                        data.country_code && data.country_code.country_code
                          ? data.country_code.country_code
                          : '-'
                      "
                    />
                  </a>
                  <br />
                  <span class="update-date"
                    >Published Date :
                    {{ $helperService.getFormatedDate(data.news_date) }}</span
                  >
                </div>
                <div class="col-lg-8 col-sm-5 pb-3 txt-center">
                  <p class="clrb" style="padding: 0; margin: 0">
                    {{ data.news_title }}
                  </p>

                  <div class="col-12 row">
                    <div class="col-6 mt-3 row">
                      <div
                        v-for="(data1, index1) in data.news_mention_executives"
                        :key="index1"
                      >
                        <div v-if="index1 <= 4">
                          <img
                            v-if="data1.executive_logo || !data1.gender"
                            style="
                              cursor: pointer;
                              border: 1px solid white; /*! padding: 0.1px; */
                              box-shadow: 18px;
                              width: 37px !important;
                              box-shadow: 0px 0px 0.5px 0.5px GREY;
                            "
                            :title="data1.executive_name"
                            v-on:click="
                              goToView(
                                '/executive-detail/' + data1.executives_id
                              )
                            "
                            :src="
                              data1.executive_logo
                                ? data1.executive_logo
                                : '/img/new.png'
                            "
                            width="50"
                            height="50"
                            :style="
                              index1 == 0 ? 'width: 31px;' : 'width: 37px;'
                            "
                            :class="index1 == 0 ? 'sm-img' : 'sm-img minus8'"
                          />
                          <img
                            v-on:click="
                              goToView(
                                '/executive-detail/' + data1.executives_id
                              )
                            "
                            style="
                              cursor: pointer;
                              border: 1px solid white; /*! padding: 0.1px; */
                              box-shadow: 18px;
                              width: 37px !important;
                              box-shadow: 0px 0px 0.5px 0.5px GREY;
                            "
                            :title="data1.executive_name"
                            v-if="
                              data1.gender == 'male' && !data1.executive_logo
                            "
                            :src="
                              data1.executive_logo
                                ? data1.executive_logo
                                : '/img/male.png'
                            "
                            width="50"
                            height="50"
                            :class="index1 == 0 ? 'sm-img' : 'sm-img minus8'"
                          />
                          <img
                            v-on:click="
                              goToView(
                                '/executive-detail/' + data1.executives_id
                              )
                            "
                            style="cursor: pointer"
                            :title="data1.executive_name"
                            v-if="
                              data1.gender == 'female' && !data1.executive_logo
                            "
                            :src="
                              data1.executive_logo
                                ? data1.executive_logo
                                : '/img/female.png'
                            "
                            width="50"
                            height="50"
                            :style="
                              index1 == 0 ? 'width: 31px;' : 'width: 37px;'
                            "
                            :class="index1 == 0 ? 'sm-img' : 'sm-img minus8'"
                          />
                        </div>
                      </div>
                      <!-- sm-img minus8 -->
                    </div>
                    <div class="col-6 mt-3 row">
                      <div
                        v-for="(data2, index2) in data.news_mention_company"
                        :key="index2"
                      >
                        <div
                          v-if="
                            index2 <= 5 && data.company_id != data2.company_id
                          "
                        >
                          <img
                            style="
                              cursor: pointer;
                              border: 1px solid white; /*! padding: 0.1px; */
                              box-shadow: 18px;
                              width: 37px !important;
                              box-shadow: 0px 0px 0.5px 0.5px GREY;
                            "
                            :title="data2.company_name"
                            v-on:click="
                              goToView('/company-detail/' + data2.company_id)
                            "
                            :src="data2.company_logo"
                            width="30"
                            height="30"
                            :style="
                              index2 == 0 ? 'width: 31px;' : 'width: 37px;'
                            "
                            :class="index2 == 0 ? 'sm-img' : 'sm-img minus8'"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Executive tags: city, skills, industry exposure -->
                  <div
                    class="news-tags"
                    v-if="data.executive_tags && data.executive_tags.length"
                  >
                    <span class="news-tags-label calibri"
                      >Executive Tags</span
                    >
                    <span
                      class="news-tag news-tag-exec"
                      v-for="(tag, tagIndex) in data.executive_tags"
                      :key="'exe-tag-' + tagIndex"
                      >{{ tag }}</span
                    >
                  </div>

                  <!-- Company tags: tags, type, size, stage -->
                  <div
                    class="news-tags"
                    v-if="data.company_tags && data.company_tags.length"
                  >
                    <span class="news-tags-label calibri">Company Tags</span>
                    <span
                      class="news-tag news-tag-company"
                      v-for="(tag, tagIndex) in data.company_tags"
                      :key="'com-tag-' + tagIndex"
                      >{{ tag }}</span
                    >
                  </div>
                </div>

                <div
                  v-if="data.is_company_logo == 1"
                  class="col-lg-1 col-sm-2 col-6 text-center"
                  style="cursor: pointer"
                  v-on:click="openLink(data.news_link)"
                >
                  <img
                    :title="data.company_name ? data.company_name : ''"
                    :src="
                      data.company_logo ? data.company_logo : '/img/new.png'
                    "
                    alt=""
                    height="60"
                    width="150"
                  />
                </div>
                <div
                  v-if="data.is_company_logo == 0"
                  v-on:click="openLink(data.news_link)"
                  style="cursor: pointer"
                  class="col-lg-1 col-sm-2 col-6 text-center"
                >
                  <img
                    :title="
                      data.publication && data.publication.name
                        ? data.publication.name
                        : ''
                    "
                    :src="
                      data.publication && data.publication.publication_logo
                        ? data.publication.publication_logo
                        : ''
                    "
                    alt=""
                    height="60"
                    width="150"
                  />
                </div>
              </div>

              <!-- <hr /> -->
              <div class="row mx-0 mb-2">
                <div class="col-lg-12 mt-4 text-center">
                  <div class="page-bottom-pagination text-right">
                    <Pagination
                      @page-change="pageChange"
                      @items-per-page-change="itemsPerPageChange"
                      ref="listPagination"
                    />
                  </div>
                </div>
              </div>
            </div>
            <ErrorComponent @retry="getList(0)" ref="errorComponent" />
          </div>
        </div>
      </div>
    </section>
  </div>

  <!-- News Section Filter View start here -->
  <div class="navbar news-offcanvas">
    <div
      :class="
        isOpenModel
          ? 'navbar-collapse offcanvas-collapse open'
          : 'navbar-collapse offcanvas-collapse close'
      "
      tabindex="-1"
      id="offcanvas2"
    >
      <div class="inner-filter-close">
        <div class="row">
          <div class="col-lg-6 col-sm-6 col-6 text-left">
            <h6
              class="mb-0"
              style="font-size: 15px; padding-top: 2px; color: #de4a38"
            >
              News
            </h6>
          </div>
          <div class="col-lg-6 col-sm-6 col-6" id="closeOffcanvas">
            <button
              class="navbar-toggler menuButton"
              v-on:click="openCloseModel()"
            >
              <img src="/img/cross.png" width="22" height="22" />
            </button>
          </div>
        </div>
      </div>
      <div class="form-group mb-3 px-3" v-if="selectedFilters.length">
        <div class="selected-filters d-flex flex-wrap mt-2">
          <span
            v-for="(filter, index) in selectedFilters"
            :key="index"
            class="selected-chip"
            style="cursor: pointer"
            @click="removeSelectedFilter(filter)"
          >
            {{ filter.name }} <span style="margin-left: 5px">&times;</span>
          </span>
        </div>
      </div>
      <div class="inner-data">
        <div class="filter-modal">
          <div class="overflowScroll">
            <div id="accordion" class="accordion">
              <div class="card mb-0">
                <!-- Current Company -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseOne"
                >
                  <a class="card-title"> Current Company </a>
                </div>
                <div id="collapseOne" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <!-- <label class="mb-1" style="font-weight: normal">Search Company</label> -->
                    <!-- <Multiselect mode="tags" trackBy="company_name" label="company_name" valueProp="id"
                    closeOnSelect="true" placeholder="Select" v-model="searchObj.new_company_ids" :options="companyList"
                    :noOptionsText="'Enter Text'" searchable="true" @search-change="searchCompanyName($event)"
                    @input="inputCurrentCompany($event)" /> -->
                    <Multiselect
                      v-model="searchObj.company_ids"
                      :options="companyList"
                      :multiple="true"
                      placeholder="Select"
                      label="company_name"
                      track-by="company_name"
                      value-prop="id"
                      searchable="true"
                      mode="tags"
                      @search-change="searchCompanyName($event)"
                      @input="onCompanyChange"
                      :show-labels="false"
                    >
                    </multiselect>
                  </div>
                </div>
                <!-- ComapnySegment -->
                <div
                  v-if="isShowSegment"
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseTwentyTwo"
                >
                  <a class="card-title">Company Segment</a>
                </div>
                <div id="collapseTwentyTwo" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(segment, index) in segmentList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.segment_ids.includes(
                            segment.id
                          ),
                          'btn-success active':
                            !searchObj.segment_ids.includes(segment.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="segment.name"
                          :value="segment.id"
                          v-model="searchObj.segment_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              segment.id,
                              'segment',
                              segment.name
                            )
                          "
                        />
                        {{ segment.name }}
                      </label>
                    </div>
                  </form>
                </div>                
                <!-- Past Company -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseTwo"
                >
                  <a class="card-title"> Past Company </a>
                </div>
                <div id="collapseTwo" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <!-- <label class="mb-1" style="font-weight: normal">Search Past Company</label> -->
                    <multiselect
                      v-model="searchObj.prev_company_ids"
                      :options="companyList"
                      :multiple="true"
                      placeholder="Select"
                      label="company_name"
                      track-by="company_name"
                      value-prop="id"
                      searchable="true"
                      mode="tags"
                      @search-change="searchCompanyName($event)"
                      @input="onPrevCompanyChange"
                      :show-labels="true"
                    >
                    </multiselect>
                  </div>
                </div>
                <!-- News Type -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseTwelve"
                >
                  <a class="card-title"> News Type </a>
                </div>
                <div id="collapseTwelve" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(type, index) in types"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.type.includes(type.lable),
                          'btn-success active': !searchObj.type.includes(
                            type.lable
                          ),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="type.value"
                          :value="type.lable"
                          v-model="searchObj.type"
                          autocomplete="off"
                          @change="
                            handleToggle(type.lable, 'news_type', type.value)
                          "
                        />
                        {{ type.value }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Industry -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseThree"
                >
                  <a class="card-title"> Industry </a>
                </div>
                <div id="collapseThree" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap">
                      <label
                        v-for="(industry, index) in getDisplayedIndustries()"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.industry_ids.includes(
                            industry.id
                          ),
                          'btn-success active':
                            !searchObj.industry_ids.includes(industry.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="industry.industry_name"
                          :value="industry.id"
                          v-model="searchObj.industry_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              industry.id,
                              'industry',
                              industry.industry_name
                            )
                          "
                        />
                        {{ industry.industry_name }}
                      </label>
                    </div>
                    <!-- View more Button -->
                    <div class="mt-2 text-right">
                      <span v-if="!showAllIndustries" 
                        @click="handleShowMore"
                        style="cursor: pointer; 
                        font-size: 14px; 
                        color: black; 
                        font-weight: 500;">
                        view more
                      </span>
                    </div>                    
                  </form>
                </div>
                <!--sub sector -->
                <div
                  v-if="isShowSubsector"
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseThree"
                >
                  <a class="card-title"> Sub Sector </a>
                </div>
                <div id="collapseThree" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(subsector, index) in subsectorList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.subsector_ids.includes(
                            subsector.id
                          ),
                          'btn-success active':
                            !searchObj.subsector_ids.includes(subsector.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="subsector.industry_name"
                          :value="subsector.id"
                          v-model="searchObj.subsector_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              subsector.id,
                              'subsector',
                              subsector.industry_name
                            )
                          "
                        />
                        {{ subsector.industry_name}}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Job Function -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  href="#collapseFour"
                >
                  <a class="card-title"> Job Function </a>
                </div>
                <div id="collapseFour" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap">
                      <label
                        v-for="(job, index) in jobFunctionList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.job_function_ids_new.includes(
                            job.id
                          ),
                          'btn-success active':
                            !searchObj.job_function_ids_new.includes(job.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="job.job_function_name"
                          :value="job.id"
                          v-model="searchObj.job_function_ids_new"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              job.id,
                              'job_function',
                              job.job_function_name
                            )
                          "
                        />
                        {{ job.job_function_name }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Company Type -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseFive"
                >
                  <a class="card-title"> Company Type </a>
                </div>
                <div id="collapseFive" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap">
                      <label
                        v-for="(comapnyType, index) in company_types"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger':
                            searchObj.company_types.includes(comapnyType),
                          'btn-success active':
                            !searchObj.company_types.includes(comapnyType),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="comapnyType"
                          :value="comapnyType"
                          v-model="searchObj.company_types"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              comapnyType,
                              'company_type',
                              comapnyType
                            )
                          "
                        />
                        {{ comapnyType }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Deal Stage -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseSix"
                >
                  <a class="card-title"> Deal Stage </a>
                </div>
                <div
                  id="collapseSix"
                  class="card-body collapse"
                  data-parent="#accordion"
                >
                  <form>
                    <div class="d-flex flex-wrap">
                      <label
                        v-for="(dealStage, index) in dealStageList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.deal_stage_ids.includes(
                            dealStage.id
                          ),
                          'btn-success active':
                            !searchObj.deal_stage_ids.includes(dealStage.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="dealStage.name"
                          :value="dealStage.id"
                          v-model="searchObj.deal_stage_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              dealStage.id,
                              'deal_stage',
                              dealStage.name
                            )
                          "
                        />
                        {{ dealStage.name }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- From date --->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseSeven"
                >
                  <a class="card-title"> From Date </a>
                </div>
                <div id="collapseSeven" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <!-- <label class="mb-0 pl-1" style="font-weight: normal">Select From Date</label> -->
                    <datepicker
                      v-model="searchObj.from_date"
                      inputFormat="dd/MM/yyyy"
                      placeholder="Select"
                      class="form-control"
                      style="background-color: white !important; height: 35px"
                      :clearable="false"
                      :upperLimit="
                        searchObj.to_date ? searchObj.to_date : new Date()
                      "
                      @click="onClickFromDate()"
                    >
                    </datepicker>
                  </div>
                </div>
                <!---- To date --->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseEight"
                >
                  <a class="card-title"> To Date </a>
                </div>
                <div id="collapseEight" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <!-- <label class="mb-0 pl-1" style="font-weight: normal">Select To Date</label> -->
                    <datepicker
                      v-model="searchObj.to_date"
                      inputFormat="dd/MM/yyyy"
                      class="form-control"
                      placeholder="Select"
                      :clearable="false"
                      style="
                        background-color: white !important;
                        z-index: 3000 !important;
                      "
                      :lowerLimit="
                        searchObj.from_date ? searchObj.from_date : null
                      "
                      :upperLimit="new Date()"
                      @click="onClickFromDate()"
                    >
                    </datepicker>
                  </div>
                </div>
                <!---- Date period --->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseNine"
                >
                  <a class="card-title"> Date period </a>
                </div>
                <div id="collapseNine" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <!-- <label class="mb-0 pl-1" style="font-weight: normal">Select Date Period</label> -->
                    <Multiselect
                      mode="single"
                      trackBy="value"
                      label="value"
                      valueProp="id"
                      v-model="searchObj.date_period"
                      :options="date_periods"
                      searchable="true"
                      placeholder="Select"
                      @change="dateFilter($event)"
                      @click="onClickDatePeriod()"
                    />
                  </div>
                </div>
                <!-- Region Past -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseTen"
                >
                  <a class="card-title"> Region </a>
                </div>
                <div
                  id="collapseTen"
                  class="card-body collapse"
                  data-parent="#accordion"
                >
                  <form>
                    <div class="d-flex flex-wrap">
                      <label
                        v-for="(region, index) in regionList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.region_ids_new.includes(
                            region.id
                          ),
                          'btn-success active':
                            !searchObj.region_ids_new.includes(region.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="region.region_name"
                          :value="region.id"
                          v-model="searchObj.region_ids_new"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              region.id,
                              'region_new',
                              region.region_name
                            )
                          "
                        />
                        {{ region.region_name }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Location -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseEleven"
                >
                  <a class="card-title"> Location </a>
                </div>
                <div id="collapseEleven" class="card-body collapse show">
                  <div class="form-group mb-3" style="margin-bottom: 10rem !important">
                    <!-- <label class="mb-0 pl-1" style="font-weight: normal">Search Location</label> -->
                    <!-- <div class="tags-container">
                    <input data-role='tags-input' placeholder="Search Location" data-placeholder="Search Location"
                      value="" />
                  </div> -->
                    <multiselect
                      v-model="searchObj.country_ids"
                      :options="cityList"
                      :multiple="true"
                      placeholder="Select"
                      label="country_name"
                      track-by="country_name"
                      value-prop="id"
                      searchable="true"
                      mode="tags"
                      @search-change="searchCityName($event)"
                      @input="onLocationChange"
                      :show-labels="false"
                    >
                    </multiselect>
                  </div>
                </div>
                <!--  -->
              </div>
            </div>
          </div>
          <hr />
          <div
            class="d-flex justify-content-between align-items-center px-3 posfixed"
          >
            <button
              v-on:click="
                getList(0);
                openCloseModel();
              "
              class="apply-btn mr-2"
            >
              Apply
            </button>
            <button
              v-on:click="
                resetFilter();
                openCloseModel();
              "
              type="button"
              class="apply-btn"
            >
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { Field } from "vee-validate";
// import Datepicker from "@vuepic/vue-datepicker";
// import "@vuepic/vue-datepicker/dist/main.css";
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "@/components/Pagination";
import CountryFlag from "vue-country-flag-next";
import datepicker from "vue3-datepicker";
import Multiselect from "@vueform/multiselect";
import moment from "moment";
export default {
  name: "News",
  components: {
    ErrorComponent,
    Pagination,
    CountryFlag,
    datepicker,
    // Field,
    Multiselect,
  },
  data() {
    return {
      id: this.$route.params.id,
      type: this.$route.params.type,
      count: 0,
      loader: true,
      is_show: false,
      isShowSubsector: false,
      showAllIndustries: false,
      showDidYouMean: false,
      isShowSegment: false,
      searchedPrompt: "",      
      company_types: [
        "Public",
        "Private",
        "Education",
        "Government",
        "Not-for-Profit",
        "Venture Funded",
        "PE Backed",
      ],
      date_periods: [
        "Last Month",
        "Last 3 Month",
        "Last 6 Month",
        "Last 1 Year",
      ],
      types: [
        {
          value: "Arrival / Departure",
          lable: "arrival_departure",
        },
        {
          value: "Internal Move",
          lable: "internal_move",
        },
        {
          value: "Lay Off",
          lable: "lay_off",
        },
        {
          value: "Own Venture",
          lable: "own_venture",
        },
        {
          value: "Terminated",
          lable: "terminated",
        },
      ],
      searchObj: {
        type: [],
        from_date: "",
        to_date: "",
        country_ids: [],
        company_types: [],
        job_function_ids_new: [],
        region_ids_new: [],
        prev_company_ids: [],
        subsector_ids: [],
        industry_ids: [],
        company_ids: [],
        deal_stage_ids: [],
        date_period: "",
        segment_ids: [],
        // only set from the dashboard sentence search
        company_sizes: [],
        skill_ids: [],
      },
      dealStageList: [],
      industryList: [],
      subsectorList: [],
      companyList: [],
      segmentList: [],
      company_ids: [],
      cityList: [],
      city_ids: [],
      regionList: [],
      jobFunctionList: [],
      cityKeyword: "",
      offset: -1,
      list: [],
      companyKeyword: "",
      industryKeyword: "",
      newsTypeKeyword: "",
      jobFunctionKeyword: "",
      regionKeyword: "",
      dealStageKeyword: "",
      subsectorKeyword: "",
      selectedFilters: [],
      isOpenModel: false,
    };
  },
  mounted() {
    if (this.id || this.type) {
      this.getExecutiveDetail(this.id, this.type);
    } else {
      this.globelSearchResult();
      this.getList(0);
      this.jobFunctionlist();
      this.getRegionlist();
      this.companylist();
    }
    this.industrylist();
    this.getDealStageList();
    this.CityList();
  },
   watch: {
    "searchObj.company_ids"(newVal) {
      if (newVal.length === 1) {
        const selectedCompanyId = newVal[0];
        this.getSegmentList(selectedCompanyId);
      } else {
        this.segmentList = [];
        this.isShowSegment = false;
        this.searchObj.segment_ids = [];
        this.selectedFilters = this.selectedFilters.filter(
          (f) => f.type !== "segment"
        );
      }
    },

    'searchObj.industry_ids'(newVal) {

      if (newVal.length === 1) {
        const selectedIndustryId = newVal[0];
        this.onIndustryChange(selectedIndustryId);
        
      } else {
        this.subsectorList = [];
        this.isShowSubsector = false;
        this.searchObj.subsector_ids = [];
        this.selectedFilters = this.selectedFilters.filter(
        (f) => !(f.type === 'subsector')
      );
      }
    },

    // Scroll hide when Offcanvas open
    isOpenModel(newVal) {
    if (newVal) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }

  },
  methods: {
    getDisplayedIndustries() {
      return this.showAllIndustries ? this.industryList : this.industryList.slice(0, 15);
    },
    handleShowMore() {
      this.showAllIndustries = true;
    },    
    openCloseModel() {
      this.isOpenModel = !this.isOpenModel;
    },
    removeSelectedFilter(filter) {
      if (filter.type === "job_function") {
        this.searchObj.job_function_ids_new =
          this.searchObj.job_function_ids_new.filter((id) => id !== filter.id);
      } else if (filter.type === "news_type") {
        this.searchObj.type = this.searchObj.type.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "industry") {
        this.searchObj.industry_ids = this.searchObj.industry_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "education") {
        this.searchObj.education_ids = this.searchObj.education_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "age_range") {
        this.searchObj.age_range_ids = this.searchObj.age_range_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "seniority") {
        this.searchObj.seniority_ids = this.searchObj.seniority_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "region_new") {
        this.searchObj.region_ids_new = this.searchObj.region_ids_new.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "region_pre") {
        this.searchObj.region_ids_prev = this.searchObj.region_ids_prev.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "company_type") {
        this.searchObj.company_types = this.searchObj.company_types.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "deal_stage") {
        this.searchObj.deal_stage_ids = this.searchObj.deal_stage_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "company") {
        this.searchObj.company_ids = this.searchObj.company_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "prevcompany") {
        this.searchObj.prev_company_ids =
          this.searchObj.prev_company_ids.filter((id) => id !== filter.id);
      } else if (filter.type === "location") {
        this.searchObj.country_ids = this.searchObj.country_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "subsector") {
        this.searchObj.subsector_ids = this.searchObj.subsector_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "segment") {
        this.searchObj.segment_ids = this.searchObj.segment_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "company_size") {
        this.searchObj.company_sizes = this.searchObj.company_sizes.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "skill") {
        this.searchObj.skill_ids = this.searchObj.skill_ids.filter(
          (id) => id !== filter.id
        );
      }

      // This line ensures it's removed visually too
      this.selectedFilters = this.selectedFilters.filter(
        (f) => !(f.id === filter.id && f.type === filter.type)
      );
    },
    globelSearchResult() {
      let filters = this.$shareService.getMapValueAndRemove("global_search_filter");      
      if (filters && Object.keys(filters).length > 0) { 				

        // Did you mean
        this.showDidYouMean = filters.flag;
        this.searchedPrompt = filters.prompt;

        let current_companyid = 
          filters.coid && filters.coid != 0 ? Number(filters.coid) : "";    // current company
        if (current_companyid) {
          this.searchObj.company_ids.push(current_companyid);
          this.company_ids.push(current_companyid);
          this.selectedFilters.push({
            id: current_companyid,
            name: "",
            type: "company",
          });
        }

        let past_companyid =
          filters.pcid && filters.pcid != 0 ? Number(filters.pcid) : "";	// past company
        if (past_companyid) {
          this.searchObj.prev_company_ids.push(past_companyid);
          this.company_ids.push(past_companyid);
          this.selectedFilters.push({
            id: past_companyid,
            name: "",
            type: "prevcompany",
          });
        }

        let newstype = filters.ntype ? filters.ntype : "";  // News Type
        if (newstype) {
          // Find the matching label from the types array
          let matchedType = this.types.find(type => type.lable === newstype);

          this.searchObj.type.push(matchedType.lable);

          this.selectedFilters.push({
            id: newstype,
            name: matchedType ? matchedType.value : newstype, 
            type: "news_type",
          });
        }

        let industryId =
          filters.iid && filters.iid != 0 ? Number(filters.iid) : "";		// Industry
        if (industryId) {
          this.searchObj.industry_ids.push(industryId);
          this.selectedFilters.push({
            id: industryId,
            name: "",
            type: "industry",
          });

            let subsectorid =
              filters.ssid && filters.ssid != 0 ? Number(filters.ssid) : "";   // Subsector
            if (subsectorid) {
              this.searchObj.subsector_ids.push(subsectorid);
              this.selectedFilters.push({
                id: subsectorid,
                name: "",
                type: "subsector",
              });  
            }
            this.getSubsectorList(industryId);
        }

        let job_function =
          filters.jid && filters.jid != 0 ? Number(filters.jid) : ""; // Job Function
        if (job_function) {
          this.searchObj.job_function_ids_new.push(job_function);
          this.selectedFilters.push({
            id: job_function,
            name: "",
            type: "job_function",
          });
        }

        let companyType = filters.ctype ?? "";  // company type
        if (companyType) {
          this.searchObj.company_types.push(
            this.$helperService.getCompanyTypeLabel(companyType)
          );
          this.selectedFilters.push({
            id: this.$helperService.getCompanyTypeLabel(companyType),
            name: this.$helperService.getCompanyTypeLabel(companyType),
            type: "company_type",
          });
        }

        let stageId =
          filters.sid && filters.sid != 0 ? Number(filters.sid) : ""; // deal stage
        if (stageId) {
          this.searchObj.deal_stage_ids.push(stageId);
          this.selectedFilters.push({
            id: stageId,
            name: "",
            type: "deal_stage",
          });
        }

        let current_regionid =
          filters.rid && filters.rid != 0 ? Number(filters.rid) : "";  // region
        if (current_regionid) {
          this.searchObj.region_ids_new.push(current_regionid);
          this.selectedFilters.push({
            id: current_regionid,
            name: "",
            type: "region_new",
          });
        }

        let countryId =
          filters.cid && filters.cid != 0 ? Number(filters.cid) : ""; // Location(country)
        if (countryId) {
          this.searchObj.country_ids.push(countryId);
          this.city_ids.push(countryId);
          this.selectedFilters.push({
            id: countryId,
            name: "",
            type: "location",
          });
        }

        let from_date =
              filters.from_date && filters.from_date != 0 ? filters.from_date : "";   // From Date

        if (from_date) {
          this.searchObj.from_date = new Date(this.$helperService.sendFormatedDate(from_date, "date"));

          let to_date = new Date();
          this.searchObj.to_date = to_date;                     // To Date
        }

        // dashboard sentence search: company size, skills, and the picked
        // names so the chips read right away
        let companySize = filters.cs ?? "";
        if (companySize) {
          this.searchObj.company_sizes.push(companySize);
          this.selectedFilters.push({
            id: companySize,
            name: companySize,
            type: "company_size",
          });
        }
        (filters.skills || []).forEach((skill) => {
          this.searchObj.skill_ids.push(skill.id);
          this.selectedFilters.push({ id: skill.id, name: skill.name, type: "skill" });
        });
        if (filters.labels) {
          this.selectedFilters.forEach((filter) => {
            if (!filter.name && filters.labels[filter.type]) {
              filter.name = filters.labels[filter.type];
            }
          });
        }
      }
    },
    onCompanyChange(selectedIds) {
      this.selectedFilters = this.selectedFilters.filter(
        (filter) => filter.type !== "company" || selectedIds.includes(filter.id)
      );

      // Add any new ones
      selectedIds.forEach((id) => {
        const exists = this.selectedFilters.some(
          (f) => f.id === id && f.type === "company"
        );
        if (!exists) {
          const company = this.companyList.find((c) => c.id === id);
          if (company) {
            this.selectedFilters.push({
              id: company.id,
              name: company.company_name,
              type: "company",
            });
          }
        }
      });
    },
    onPrevCompanyChange(selectedIds) {
      this.selectedFilters = this.selectedFilters.filter(
        (filter) =>
          filter.type !== "prevcompany" || selectedIds.includes(filter.id)
      );

      // Add any new ones
      selectedIds.forEach((id) => {
        const exists = this.selectedFilters.some(
          (f) => f.id === id && f.type === "prevcompany"
        );
        if (!exists) {
          const company = this.companyList.find((c) => c.id === id);
          if (company) {
            this.selectedFilters.push({
              id: company.id,
              name: company.company_name,
              type: "prevcompany",
            });
          }
        }
      });
    },
    onLocationChange(selectedIds) {
      this.selectedFilters = this.selectedFilters.filter(
        (filter) =>
          filter.type !== "location" || selectedIds.includes(filter.id)
      );

      // Add any new ones
      selectedIds.forEach((id) => {
        const exists = this.selectedFilters.some(
          (f) => f.id === id && f.type === "location"
        );
        if (!exists) {
          const country = this.cityList.find((c) => c.id === id);
          if (country) {
            this.selectedFilters.push({
              id: country.id,
              name: country.country_name,
              type: "location",
            });
          }
        }
      });
    },
    handleToggle(id, type, name) {
      const exists = this.selectedFilters.find(
        (item) => item.id === id && item.type === type
      );

      if (!exists) {
        this.selectedFilters.push({
          id: id,
          name: name,
          type: type,
        });
      } else {
        this.selectedFilters = this.selectedFilters.filter(
          (item) => !(item.id === id && item.type === type)
        );
      }
    },
    getAdvanceSearch() {
      this.is_show = !this.is_show;
    },
    searchCityName(e) {
      this.cityKeyword = e;
      this.CityList();
    },
    searchRegionName(e) {
      this.regionKeyword = e;
      this.getRegionlist();
    },
    searchJobFunctionName(e) {
      this.jobFunctionKeyword = e;
      this.jobFunctionlist();
    },
    searchDealStage(e) {
      this.dealStageKeyword = e;
      this.getDealStageList();
    },
    getRegionlist() {
      var obj = {};
      if (this.regionKeyword) {
        obj.keyword = this.regionKeyword;
      }
      this.$api
        .getAPI({
          _action: "/region/list",
          _body: obj,
        })
        .then((res) => {
          this.regionList = res;
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "region_new"
                ) {
                  this.selectedFilters[i].name = res[j].region_name;
                }
              }
            }
          }
        })
        .catch(() => {});
    },
    jobFunctionlist() {
      var obj = {};
      if (this.jobFunctionKeyword) {
        obj.keyword = this.jobFunctionKeyword;
      }
      this.$api
        .getAPI({
          _action: "/job/function/list",
        })
        .then((res) => {
          this.jobFunctionList = res;
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "job_function"
                ) {
                  this.selectedFilters[i].name = res[j].job_function_name;
                }
              }
            }
          }          
        })
        .catch(() => {});
    },
    CityList() {
      var obj = {};
      if (this.cityKeyword) {
        obj.keyword = this.cityKeyword;
      }
      if ((this.city_ids, length > 0)) {
        obj.city_ids = this.city_ids;
      }

      this.$api
        .getAPI({
          _action: "/country/list",
          _body: obj,
        })
        .then((res) => {
          if (this.cityKeyword || this.city_ids?.length > 0) {
            this.cityList = res;
            if (this.selectedFilters && this.selectedFilters.length > 0) {
              for (var i in this.selectedFilters) {
                for (var j in res) {
                  if (
                    res[j].id == this.selectedFilters[i].id &&
                    this.selectedFilters[i].type == "location"
                  ) {
                    this.selectedFilters[i].name = res[j].country_name;
                  }
                }
              }
            }
          } else {
            // this.cityList = [];
          }
        })
        .catch(() => {});
    },
    getDealStageList() {
      this.$api
        .getAPI({
          _action: "/deal/stage/list",
        })
        .then((res) => {
          this.dealStageList = res;
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "deal_stage"
                ) {
                  this.selectedFilters[i].name = res[j].name;
                }
              }
            }
          }
        })
        .catch(() => {});
    },
    resetFilter() {
      this.searchObj = {};
      this.searchObj.type = "";
      this.searchObj.from_date = "";
      this.searchObj.to_date = "";
      this.searchObj.industry_ids = [];
      this.searchObj.company_ids = [];
      this.searchObj.country_ids = [];
      this.searchObj.company_types = [];
      this.searchObj.date_period = "";
      this.searchObj.job_function_ids_new = [];
      this.searchObj.region_ids_new = [];
      this.searchObj.deal_stage_ids = [];
      this.searchObj.subsector_ids = [];
      this.searchObj.company_sizes = [];
      this.searchObj.skill_ids = [];
      this.isShowSubsector = false;
      this.selectedFilters = [];
      this.showDidYouMean = false;
      this.getList(0);
    },
    getExecutiveDetail(id, type) {
      if (id && type) {
        this.searchObj.executive_id = id;
      } else {
        this.searchObj.company_ids.push(Number(id));
        this.company_ids.push(Number(id));
        this.selectedFilters.push({
          id: Number(id),
          name: '',
          type: "company",
        });
      }
      this.companylist(); 
      this.getList(0);
      this.jobFunctionlist();
      this.getRegionlist();
    },
    openLink(url) {
      window.open(url);
    },
    searchNewsType(e) {
      this.newsTypeKeyword = e;
      this.industrylist();
    },
    searchIndustryName(e) {
      this.industryKeyword = e;
      this.industrylist();
    },
    getSegmentList(id) {
      if (!id) return;
      this.$api
        .getAPI({
          _action: "/segment/list/" + id,
        })
        .then((res) => {
          res = res.list;
          this.segmentList = res;

          // Only show segment dropdown if there are segment(of company) available
          if (this.segmentList.length > 0) {
            this.isShowSegment = true;
          } else {
            this.isShowSegment = false;
          }
        })
        .catch(() => {
          this.isShowSubsector = false;
        });
    },    
    searchCompanyName(e) {
      this.companyKeyword = e;
      this.companylist();
    },
    companylist() {
      var obj = {};
      if (this.companyKeyword) {
        obj.keyword = this.companyKeyword;
      }
      if (this.company_ids) {
        obj.company_ids = this.company_ids;
      }

       if (this.selectedFilters && this.selectedFilters.length > 0) {
      var selectedCompanies = this.selectedFilters
        .filter((filter) => filter.type == "company")
        .map((filter) => filter.id);

      var selectedPrevCompanies = this.selectedFilters
        .filter((filter) => filter.type == "prevcompany")
        .map((filter) => filter.id);

      if(selectedPrevCompanies){
        selectedCompanies.push(...selectedPrevCompanies);
      }

      if (selectedCompanies) {
        obj.company_ids = selectedCompanies;
        this.company_ids = selectedCompanies;
      }
    }

      this.$api
        .getAPI({
          _action: "/company/list",
          _body: obj,
        })
        .then((res) => {
          if (this.companyKeyword || this.company_ids?.length > 0) {
            this.companyList = res;
            if (this.selectedFilters && this.selectedFilters.length > 0) {
              for (var i in this.selectedFilters) {
                for (var j in res) {
                  if (
                    res[j].id == this.selectedFilters[i].id &&
                    this.selectedFilters[i].type == "company"
                  ) {
                    this.selectedFilters[i].name = res[j].company_name;
                  } else if (
                    res[j].id == this.selectedFilters[i].id &&
                    this.selectedFilters[i].type == "prevcompany"
                  ) {
                    this.selectedFilters[i].name = res[j].company_name;
                  }
                }
              }
            }
          } else {
            this.companyList = [];
          }
        })
        .catch(() => {});
    },
    closesub(e) {
      if (!e) {
        this.searchObj.subsector_ids = [];
      }
    },
    onIndustryChange(selectedIndustryId) {
      if (selectedIndustryId) {
        this.subsectorList = [];
        this.isShowSubsector = false;
        this.getSubsectorList(selectedIndustryId);
      } else {
        this.isShowSubsector = false;
      }
    },
    industrylist() {
      this.$api
        .getAPI({
          _action: "/industry/list",
        })
        .then((res) => {
          this.industryList = res;
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "industry"
                ) {
                  this.selectedFilters[i].name = res[j].industry_name;
                }
              }
            }
          }          
        })
        .catch(() => {});
    },
    getSubsectorList(id) {
      this.$api
        .getAPI({
          _action: "/subsectors/list/" + id,
        })
        .then((res) => {
          res = res.list;
          this.subsectorList = res;

          // Only show subsector dropdown if there are subsectors(of industry) available
          if (this.subsectorList.length > 0) {
            this.isShowSubsector = true;
            this.is_show = true;
          } else {
            this.isShowSubsector = false;
          }

          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "subsector"
                ) {
                  this.selectedFilters[i].name = res[j].industry_name;
                }
              }
            }
          }
        })
        .catch(() => {
          this.isShowSubsector = false;
        });
    },
    geteComponydetail(id) {
      if (id) {
        this.$api
          .getAPI({
            _action: "/company/detail/" + id,
          })

          .then((res) => {
            this.searchObj.industry_ids = res.industry_ids;
          })
          .catch(() => {});
      }
    },
    onClickFromDate() {
      this.searchObj.date_period = "";
    },
    dateFilter(e) {
      if (!e) {
        this.searchObj.date_period = "";
      }
    },
    onClickDatePeriod() {
      this.searchObj.from_date = "";
      this.searchObj.to_date = "";
      this.searchObj.start_date = "";
      this.searchObj.end_date = "";
    },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    goToView(url) {
      this.searchObj.is_show = this.is_show;
      this.$shareService.setMapValue("news_page_filter", this.searchObj);
      this.$router.push(url);
    },
    getList(page) {
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];
      if (this.searchObj.from_date) {
        this.searchObj.start_date = moment(this.searchObj.from_date).format(
          "DD-MM-YYYY"
        );
      }
      if (this.searchObj.to_date) {
        this.searchObj.end_date = moment(this.searchObj.to_date).format(
          "DD-MM-YYYY"
        );
      }
      if (!this.searchObj.date_period) {
        this.searchObj.date_period = "";
      }
      if (!this.searchObj.prev_company_ids) {
        this.searchObj.prev_company_ids = [];
      }
      if (!this.searchObj.job_function_ids_new) {
        this.searchObj.job_function_ids_new = [];
      }
      if (!this.searchObj.region_ids_new) {
        this.searchObj.region_ids_new = [];
      }
      if (!this.searchObj.type) {
        this.searchObj.type = [];
      }
      if (!this.searchObj.country_ids) {
        this.searchObj.country_ids = [];
      }
      if (!this.searchObj.company_types) {
        this.searchObj.company_types = [];
      }
      if (!this.searchObj.keyword) {
        this.searchObj.keyword = "";
      }
      if (!this.searchObj.industry_ids) {
        this.searchObj.industry_ids = [];
      }
      if (!this.searchObj.company_ids) {
        this.searchObj.company_ids = [];
      }
      if (this.offset != page) {
        this.searchObj.offset = page;
      } else {
        this.searchObj.offset = page;
      }
      var filter_obj = this.$shareService.getMapValue("news_page_filter")
        ? this.$shareService.getMapValue("news_page_filter")
        : null;
      if (filter_obj) {
        this.searchObj = filter_obj;
        this.is_show = this.searchObj.is_show;
        this.$shareService.getMapValueAndRemove("news_page_filter");
        if (this.searchObj.company_ids) {
          this.company_ids.push(this.searchObj.company_ids);
          this.companylist();
        }
      }
      this.$api
        .getAPI({
          _action: "/news/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.offset = res.next_offset;
          this.count = res.count;
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
                this.$refs.listPagination.setCurrentPage(
                  this.searchObj.offset + 1
                );
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "No news list available");
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
/* ---- News card tags ---- */
.news-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  text-align: left;
  margin-top: 10px;
}

.news-tags-label {
  flex: 0 0 auto;
  margin-right: 8px;
  font-size: 10px;
  font-style: italic;
  color: #98a2b3;
}

.news-tag {
  display: inline-block;
  margin: 2px 4px 2px 0;
  padding: 1px 7px;
  border: 1px solid transparent;
  border-radius: 4px;
  font-size: 10.5px;
  line-height: 1.5;
  white-space: nowrap;
}

/* two tints so executive and company tags are told apart at a glance */
.news-tag-exec {
  background: #ecfdf3;
  border-color: #d3f8df;
  color: #067647;
}

.news-tag-company {
  background: #eef2ff;
  border-color: #e0e5ff;
  color: #4338ca;
}

.multiselect {
  background: #f0f0f0;
  height: 35px;
  border: 1px solid;
}

.multiselect-tag {
  background: #9cc338 !important;
}

[data-toggle="buttons"] > .btns input[type="checkbox"],
[data-toggle="buttons"] > .btn-group > .btns input[type="checkbox"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
[type="radio"]:checked,
[type="radio"]:not(:checked) {
  position: relative !important;
  left: 0 !important;
}
label.btns.btn-block.btn-success.active,
label.btns.btn-block.btn-danger {
  border-radius: 15px;
  font-size: 11px;
  color: black;
  margin: 2px;
  padding: 4px 12px;
  font-weight: normal;
  cursor: pointer;
}
label.btns.btn-block.btn-success.active {
  background-color: #e2f0d9;
}
label.btns.btn-block.btn-danger {
  background: #d2ecff;
}
.btn-block {
  display: inline-block;
  width: auto;
}
.card .card-body {
  padding: 2px;
  margin: 0;
}
.input-tags {
  width: 100%;
  padding: 15px;
  display: block;
  margin: 0 auto;
}
.tags-container .tag {
  position: relative;
  padding-right: 24px;
  padding-top: 0.4em;
  padding-bottom: 0.4em;
  padding-left: 0.4em;
  font-size: 85%;
  margin-left: 0.25rem;
}
.card-title {
  font-size: 13px;
}

.selected-chip {
  background-color: #d2ecff; /* light green */
  border-radius: 15px;
  font-size: 12px;
  color: black;
  margin: 2px;
  padding: 10px 20px;
  font-weight: normal;
  cursor: pointer;
}

.remove-icon {
  margin-left: 8px;
  cursor: pointer;
  font-weight: bold;
}
</style>
